import type { TRotinaArquivo } from '@/features/simulador/brasil/http/create-simulacao.service'
import { criarRotinaArquivoRegistry } from '@/features/simulador/shared/domain/criar-rotina-arquivo-registry'

export const rotinaArquivoRegistry = criarRotinaArquivoRegistry<TRotinaArquivo>()
